import { I18nProvider, Refine, ResourceProps } from '@refinedev/core';
import { DevtoolsPanel, DevtoolsProvider } from '@refinedev/devtools';
import { RefineKbar, RefineKbarProvider } from '@refinedev/kbar';
import '@refinedev/antd/dist/reset.css';
import routerBindings, {
  DocumentTitleHandler,
  UnsavedChangesNotifier,
} from '@refinedev/react-router-v6';
import { dataProvider } from './rest-data-provider';
import { App as AntdApp } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { authProvider } from './authProvider';
import { ColorModeContextProvider } from './contexts/color-mode';
import { customTitleHandler } from './Helpers';
import './index.css';
import { useNotificationProvider } from '@refinedev/antd';
import { axiosInstance } from './rest-data-provider/utils';
import {
  resources,
  academicSupervisorProgramHead,
  systemAdminResources,
} from './configResources/resources';
import { AppRoutes } from './configResources';
import './i18n';
import { useTranslation } from 'react-i18next';
import useLangStore from './core/lang';
import { useEffect, useState } from 'react';
import './styles/global.css';
import { useProfileStore } from './core';

function App() {
  const [recourseTouUse, setRecourseTouUse] =
    useState<ResourceProps[]>(resources);
  const { t, i18n } = useTranslation();
  const { setLocale, locale } = useLangStore();
  const { userData } = useProfileStore();
  const i18nProvider: I18nProvider = {
    translate: (key: string, params: object) => {
      // @ts-ignore
      return t(key, params);
    },
    changeLocale: (lang: string) => {
      i18n.changeLanguage(lang);
      setLocale(lang);
      localStorage.setItem('direction', lang === 'ar' ? 'rtl' : 'ltr');
      localStorage.setItem('lang', lang);
    },
    getLocale: () => i18n.language,
  };
  useEffect(() => {
    if (locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);
  useEffect(() => {
    const direction = localStorage.getItem('direction');
    if (direction) {
      document.documentElement.dir = direction;
    } else {
      document.documentElement.dir = 'ltr';
    }
  }, []);
  useEffect(() => {
    if (userData) {
      if (
        userData?.account?.admin?.admin_type === 'ACADEMIC_SUPERVISOR' ||
        userData?.account?.admin?.admin_type === 'PROGRAM_HEAD'
      ) {
        setRecourseTouUse(academicSupervisorProgramHead);
      } else if (userData?.account?.admin?.admin_type === 'SYSTEM_ADMIN') {
        setRecourseTouUse(systemAdminResources);
      } else {
        setRecourseTouUse(resources);
      }
    }
  }, [userData]);
  return (
    <BrowserRouter>
      <RefineKbarProvider>
        <ColorModeContextProvider>
          <AntdApp>
            <DevtoolsProvider>
              <Refine
                i18nProvider={i18nProvider}
                dataProvider={dataProvider(
                  import.meta.env.API_URL!,
                  axiosInstance
                )}
                notificationProvider={useNotificationProvider}
                routerProvider={routerBindings}
                authProvider={authProvider}
                resources={recourseTouUse}
                options={{
                  syncWithLocation: true,
                  warnWhenUnsavedChanges: true,
                  useNewQueryKeys: true,
                  projectId: 't6Hi8P-XBd9YB-jPi8E5',
                }}
              >
                <AppRoutes />
                <RefineKbar />
                <UnsavedChangesNotifier />
                <DocumentTitleHandler handler={customTitleHandler} />
              </Refine>
              <DevtoolsPanel />
            </DevtoolsProvider>
          </AntdApp>
        </ColorModeContextProvider>
      </RefineKbarProvider>
    </BrowserRouter>
  );
}

export default App;
